import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "homeKepegawaian";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const homeList = "Kepegawaian/Home/list/";
export const homeListCuti = "Kepegawaian/Home/listcuti/";
export const homeInactive = "Kepegawaian/Home/inactive/";
export const homeActive = "Kepegawaian/Home/active/";

export const employeeCreate = "Kepegawaian/Home/employeeCreate/";
export const checkEnrollExist = "Kepegawaian/Home/checkEnrollExist/";

export const masterGajiwebSatker = "Master/GajiWeb/listSatker/";
export const masterGajiwebBankSpan = "Master/GajiWeb/listBankSpan/";
export const masterRegion = "Master/List/region/";
export const masterReligion = "Master/Religion/list/";
export const masterBloodType = "Master/BloodType/list/";
export const polaKerjaList = "Master/polaKerjaPegawai/listWorkingPattern/";
export const masterMaritalStatus = "Master/MaritalStatus/list/";
export const masterBank = "Master/Bank/list/";
export const masterEmployeeType = "Master/EmployeeType/list/";
export const masterEmployeeStatus = "Master/EmployeeStatus/list/";
export const masterEmployeeStatusDescription =
  "Master/EmployeeStatusDescription/list/";
export const masterEmployeeStatusPosition =
  "Master/EmployeeStatusPosition/list/";
export const masterWorkUnit = "Master/List/workUnit/";
export const masterWorkUnitEchelonTwo = "Master/List/workUnitEchelonTwo/";
export const masterPosition = "Master/List/position/";
export const masterRank = "Master/List/rank/";
export const masterEducation = "Master/List/education/";
export const masterEchelon = "Master/List/echelon/";
export const masterEmployeeCategories = "Master/List/employeeCategories/";
export const masterMinistries = "Master/List/ministries/";

export const downloadDRH = "Kepegawaian/DRH/download/";
export const exportExcel = "Kepegawaian/Home/exportExcel/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
